export enum DeviceType {
  MobileApp,
  LargeScreen = 1366,
  MediumSize = 1024,
  SmallScreen = 991
}
